import axios from 'axios'

import { apiConfig } from '@/config'

export function setUpApiConfig() {
    axios.defaults.baseURL = apiConfig.FACTORYBASE_API_URI
    axios.defaults.timeout = apiConfig.TIMEOUT
}

export function setAuthToken(token) {
    axios.defaults.headers.common['Authorization'] = `JWT ${token}`
}

export function clearAuthToken() {
    delete axios.defaults.headers.common['Authorization']
}
